<template>
  <Modal
    id="LeaveApprove"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="$t('leaveApprove.name.title')"
  >
    <Descriptions :title="$t('leaveApprove.name.employeeInfo')">
      <DescriptionsItem :label="$t('leave.field.id_lea')">{{
        data.idLea
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.id_emp')">{{
        data.employeeNameTw
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.leave_type')">{{
        selectList.leaveTypeList.find((item) => item.value === data.leaveType)
          .label
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.start_time')">{{
        data.startTime
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.end_time')">{{
        data.endTime
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.duration')">{{
        data.duration
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.reason')">{{
        data.reason
      }}</DescriptionsItem>
      <!-- <DescriptionsItem :label="$t('leave.field.approver_id')">{{
        data.approverId
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.approve_time')">{{
        data.approveTime
      }}</DescriptionsItem> -->
      <!-- <DescriptionsItem :label="$t('leave.field.cc')">{{
        data.cc
      }}</DescriptionsItem> -->
      <DescriptionsItem :label="$t('leave.field.remark')">{{
        data.remark
      }}</DescriptionsItem>
      <!-- <DescriptionsItem :label="$t('leave.field.picture_url')">
        <Image
          :width="200"
          :src="data.pictureUrl"
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
        />
      </DescriptionsItem> -->
    </Descriptions>
    <Descriptions :title="$t('leaveApprove.name.remainingVacation')">
      <!-- <DescriptionsItem :label="$t('remainingVacation.field.id_rem_vac')">{{remainingVacation.idRemVac}}</DescriptionsItem>
        <DescriptionsItem :label="$t('remainingVacation.field.id_emp')">{{remainingVacation.idEmp}}</DescriptionsItem> -->
      <DescriptionsItem
        :label="$t('remainingVacation.field.annual_leave_days')"
        >{{ remainingVacation.annualLeaveDays }}</DescriptionsItem
      >
      <DescriptionsItem
        :label="$t('remainingVacation.field.maternity_leave_days')"
        >{{ remainingVacation.maternityLeaveDays }}</DescriptionsItem
      >
      <DescriptionsItem
        :label="$t('remainingVacation.field.paternity_leave_days')"
        >{{ remainingVacation.paternityLeaveDays }}</DescriptionsItem
      >
      <DescriptionsItem
        :label="$t('remainingVacation.field.remaining_annual_leave_days')"
        >{{ remainingVacation.remainingAnnualLeaveDays }}</DescriptionsItem
      >
      <DescriptionsItem
        :label="$t('remainingVacation.field.remaining_maternity_leave_days')"
        >{{ remainingVacation.remainingMaternityLeaveDays }}</DescriptionsItem
      >
      <DescriptionsItem
        :label="$t('remainingVacation.field.remaining_paternity_leave_days')"
        >{{ remainingVacation.remainingPaternityLeaveDays }}</DescriptionsItem
      >
      <DescriptionsItem :label="$t('remainingVacation.field.year')">{{
        remainingVacation.year
      }}</DescriptionsItem>
    </Descriptions>
    <Descriptions :title="$t('leaveApprove.name.historyLeave')"> </Descriptions>
    <Row>
      <Col :span="24">
        <Table
          :columns="columns"
          :dataSource="list"
          :scroll="{ x: true }"
          rowKey="idLea"
          :loading="loading"
          :pagination="false"
        >
        </Table>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Descriptions,
  DescriptionsItem,
  Row,
  Col,
  Table,
  Image,
  message,
} from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { LeaveApprove } from "@/api/LeaveApprove";
import { RemainingGetByIdEmp } from "@/api/RemainingGetByIdEmp";
import { LeaveGetHistoryLeave } from "@/api/LeaveGetHistoryLeave";
import moment from "moment";

export default {
  name: "LeaveDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
    Image,
    Row,
    Col,
    Table,
    message,
  },
  data() {
    return {
      data: {},
      remainingVacation: {},
      selectList: {
        leaveTypeList: [
          { value: 1, label: "調休" },
          { value: 2, label: "年假" },
          { value: 3, label: "產假" },
          { value: 4, label: "侍產假" },
          { value: 5, label: "事假" },
          { value: 6, label: "病假" },
          { value: 7, label: "婚假" },
        ],
      },
      visible: false,
      list: [],
      columns: [
        {
          title: this.$t("leave.table.id_lea"),
          fixed: "left",
          dataIndex: "idLea",
          key: "idLea",
        },
        {
          title: this.$t("leave.table.id_emp"),
          dataIndex: "employeeNameTw",
          key: "employeeNameTw",
        },
        {
          title: this.$t("leave.table.leave_type"),
          dataIndex: "leaveType",
          key: "leaveType",
          customRender: ({ text }) => {
            return this.selectList.leaveTypeList.find(
              (item) => item.value === text
            ).label;
          },
        },
        {
          title: this.$t("leave.table.start_time"),
          dataIndex: "startTime",
          key: "startTime",
          customRender: ({ text, record }) => {
            if (
              record.leaveType === 2 ||
              record.leaveType === 3 ||
              record.leaveType === 4
            ) {
              return moment(text).format("YYYY-MM-DD");
            } else {
              return moment(text).format("YYYY-MM-DD HH:mm:ss");
            }
          },
        },
        {
          title: this.$t("leave.table.end_time"),
          dataIndex: "endTime",
          key: "endTime",
          customRender: ({ text, record }) => {
            if (
              record.leaveType === 2 ||
              record.leaveType === 3 ||
              record.leaveType === 4
            ) {
              return moment(text).format("YYYY-MM-DD");
            } else {
              return moment(text).format("YYYY-MM-DD HH:mm:ss");
            }
          },
        },
        {
          title: this.$t("leave.table.duration"),
          dataIndex: "duration",
          key: "duration",
          customRender: ({ text, record }) => {
            if (
              record.leaveType === 2 ||
              record.leaveType === 3 ||
              record.leaveType === 4
            ) {
              return text + "天";
            } else {
              return text + "分鐘";
            }
          },
        },
        {
          title: this.$t("leave.table.reason"),
          dataIndex: "reason",
          key: "reason",
        },
        // {
        //   title: this.$t("leave.table.picture_url"),
        //   dataIndex: "pictureUrl",
        //   key: "pictureUrl",
        // },
        {
          title: this.$t("leave.table.approver_id"),
          dataIndex: "approver",
          key: "approver",
        },
        {
          title: this.$t("leave.table.approve_time"),
          dataIndex: "approveTime",
          key: "approveTime",
        },
        { title: this.$t("leave.table.cc"), dataIndex: "cc", key: "cc" },
        {
          title: this.$t("leave.table.remark"),
          dataIndex: "remark",
          key: "remark",
        },
        {
          key: "action",
          align: "right",
          slots: { title: "actionTitle", customRender: "action" },
        },
      ],
    };
  },
  computed: {},
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.getRemainingVacation();
      this.get_list();
      this.visible = true;
    },
    submit() {
      let api = new LeaveApprove();
      api
        .post({
          idLea: this.data.idLea,
        })
        .then((response, any) => {
          if (0 == parseInt(response.data.code)) {
            message.success(response.data.msg);
            this.$emit("updateList");
            this.visible = false;
          } else {
            message.error(response.data.msg);
          }
        });
    },
    getRemainingVacation() {
      let api = new RemainingGetByIdEmp();
      api
        .get({
          idEmp: this.data.idEmp,
        })
        .then((response, any) => {
          if (0 == parseInt(response.data.code)) {
            this.remainingVacation = response.data.data;
          } else {
            message.error(response.data.msg);
          }
        });
    },
    get_list() {
      this.loading = true;
      const api = new LeaveGetHistoryLeave();
      const getData = {
        idEmp:this.data.idEmp
      }
      // if (this.searchForm.search != "") getData.search = this.searchForm.search
      // if (this.searchForm.status != 0) getData.status = this.searchForm.status
      // if (this.searchForm.order != "") getData.order = this.searchForm.order
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data;
            this.list = dataTmp.data;
          } else {
            this.list = [];
          }
        });
    },
  },
};
</script>

<style lang="less">
</style>